import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { useFilters } from '@domain-group/react-hooks'

import {
  Box, Button, DashboardModule,
} from '@domain-group/suit-theme'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import useArtworkTemplateGroupLink from '@hooks/useArtworkTemplateGroupLink'
import useArtworkTemplateGroupLinks from '@hooks/useArtworkTemplateGroupLinks'
import useArtworkTemplateGroup from '@hooks/useArtworkTemplateGroup'

import ArtworkTemplateGroupLinkListItem from './ArtworkTemplateGroupLinkListItem'

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'priceListName',
      label: 'Filter by Name',
    },
  ]
}

interface ArtworkTemplateGroupLinkListsProps {
  filters: {
    artworkTemplateGroupId: number,
    entityTitle: string,
    entityType: string,
  },
}

const ArtworkTemplateGroupLinks = (props: ArtworkTemplateGroupLinkListsProps) => {
  const { filters } = props
  const { artworkTemplateGroupId, entityTitle, entityType } = filters || {}

  const filterPayload = useFilters()

  const {
    pageFilters,
  } = filterPayload

  const { artworkTemplateGroup } = useArtworkTemplateGroup({ id: artworkTemplateGroupId })
  const { productLineId } = artworkTemplateGroup

  const options = {
    filters: { artworkTemplateGroupId, entityType, ...pageFilters },
    performHttpRequests: !!artworkTemplateGroupId,
    requestOptions: {
      include: 'ArtworkTemplateGroup',
    },
    sortKey: 'artworkTemplateGroup',
  }

  const artworkTemplateGroupLinksPayload = useArtworkTemplateGroupLinks(options)

  const {
    callbacks: {
      launchBulkCreateArtworkTemplateGroupLinksModal,
    },
  } = useArtworkTemplateGroupLink({ artworkTemplateGroupId, entityType })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredArtworkTemplateGroupLinks,
    filteredArtworkTemplateGroupLinksCount,
    hasFilteredArtworkTemplateGroupLinks,
    loading,
  } = artworkTemplateGroupLinksPayload

  return (
    <DashboardModule
      boxProps={{ borderBottom: loading ? 'none' : '1px solid lineColor' }}
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title={entityTitle}
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <Box flexDirection="column">
        <DashboardModule.ScrollableSection flexDirection="column">
          {!loading && !hasFilteredArtworkTemplateGroupLinks && (
            <DashboardModule.BlankState>
              <DashboardModule.BlankState.Title>
                No Links present
              </DashboardModule.BlankState.Title>

              <DashboardModule.BlankState.Paragraph>
                Please adjust your filters or link an entity
              </DashboardModule.BlankState.Paragraph>
            </DashboardModule.BlankState>
          )}

          {!loading && filteredArtworkTemplateGroupLinks.map(link => (
            <ArtworkTemplateGroupLinkListItem
              key={link.id}
              artworkTemplateGroupLink={link}
            />
          ))}
        </DashboardModule.ScrollableSection>

        <DashboardModule.LoadMoreFooter
          boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
          callbacks={{ loadMore }}
          canLoadMore={canLoadMore}
          entityCount={filteredArtworkTemplateGroupLinksCount}
          loading={loading}
        >
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => launchBulkCreateArtworkTemplateGroupLinksModal({ productLineId })}
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Assign {entityTitle}
          </Button>
        </DashboardModule.LoadMoreFooter>
      </Box>
    </DashboardModule>
  )
}

export default ArtworkTemplateGroupLinks
